import type { IllustrationProps } from "./types-illustration";
import { useIllustration } from "./use-illustration";
import { IllustrationView } from "./view-illustration";

/** SVG inline do Figma com cores por `var(--ds-color-*)`; a arte e a acessibilidade vêm do `useIllustration`. */
export function Illustration(props: IllustrationProps) {
  const viewModel = useIllustration(props);

  return <IllustrationView {...viewModel} />;
}
Illustration.displayName = "Illustration";
